<template>
  <div class="menuSuperior">
    <div class="row">
      <div class="col-sm-4">
        <figure>
          <a href="#">
            <img src="/static/resources/images/logo_white.png" alt="Logo Audiotext">
          </a>
        </figure>
      </div>
      <div class="col-sm-8">
        <div class="esquerdaMenuSuperior">
          <ul class="listaMenuSuperior">
            <li><span class="user">Olá, </span>{{ user.first_name }} {{ user.last_name }}</li>
            <li v-on:click="logout()" title="Sair">
              <a href="#" class="menu sair"><i class="fas fa-sign-out-alt"></i>
                <span> Sair</span>
              </a></li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'headerbar',
  data() {
    return {};
  },
  mounted() {},
  computed: {
    user() {
      return this.$store.state.auth.user;
    },
  },
  methods: {
    async logout() {
      await this.$store.dispatch('auth/signOut');
      this.$router.push({ name: 'auth' });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Nav/Headerbar.vue